import React, { Component } from 'react';
import { Table } from 'antd';

class MachineQuotationListView extends Component {
    render() {
        const columns = [
            {
                title: 'Fecha',
                dataIndex: 'time',
                key: 'time',
                render: text => (new Date(text).toDateString()),
            },
            {
                title: 'Usuario',
                dataIndex: 'author',
                key: 'author',
            },
            {
                title: 'Costo',
                dataIndex: 'cost',
                key: 'cost',
            },

        ];
        return (
            <Table
                columns={columns}
                expandedRowRender={record => (
                    <div>
                        <p style={{ margin: 0 }}>
                            {record.details}
                        </p>
                        { record.file != null && (
                            <a target="_blank" rel="noopener noreferrer" href={record.file}>
                                Descargar Archivo
                            </a>
                        )}
                    </div>
                )}
                dataSource={this.props.quotations}
            />
        );
    }
}

export default MachineQuotationListView;



// WEBPACK FOOTER //
// ./src/components/views/MachineQuotationListView.js